import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText, Settings, ArrowRight, ShieldCheck } from 'lucide-react';
const mechanismSteps = [{
  icon: FileText,
  label: 'Inputs',
  desc: 'Ficha de Oferta (fuente única)'
}, {
  icon: Settings,
  label: 'Reglas',
  desc: 'Anti-humo + anti-alucinación'
}, {
  icon: ArrowRight,
  label: 'Salidas',
  desc: 'Tablas/guiones/reportes con formato fijo'
}, {
  icon: ShieldCheck,
  label: 'Pruebas',
  desc: 'QA de 60 segundos para detectar genérico'
}];
const deliverables = ['Ruta de 72 horas', "Plantilla 'Ficha de Oferta' (fuente única)", 'Instrucciones pegables para el Custom GPT Núcleo', '3 prompts maestros (Contenido, DMs, Reporting)', 'Pack de estructuras de contenido por ángulos', 'Scripts por temperatura (frío/tibio/caliente)', 'Troubleshooting (25 fallos + fixes)', 'Plan de mantenimiento 30 días'];
export function MechanismSection() {
  return <section className="w-full py-24 px-6 bg-[#0a0f0d]" data-id="element-36">
      <div className="max-w-4xl mx-auto space-y-24" data-id="element-37">
        {/* Unique Mechanism */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-12" data-id="element-38">
          <div className="text-center space-y-4" data-id="element-39">
            <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0]" data-id="element-40">
              Checklist de Entrenamiento
            </h2>
            <p className="text-[#00d4aa] text-lg" data-id="element-41">
              Inputs → Reglas → Salidas → Pruebas
            </p>
          </div>

          <div className="bg-[#050505] border border-gray-800 p-8 md:p-12 rounded-2xl" data-id="element-42">
            <p className="text-xl text-white mb-8 text-center" data-id="element-43">
              Aquí está la diferencia. No es "más ideas". Es control.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-44">
              {mechanismSteps.map((step, i) => <div key={i} className="flex items-start space-x-4" data-id="element-45">
                  <div className="mt-1" data-id="element-46">
                    <step.icon className="w-6 h-6 text-[#00d4aa]" data-id="element-47" />
                  </div>
                  <div data-id="element-48">
                    <h4 className="text-white font-bold" data-id="element-49">{step.label}</h4>
                    <p className="text-gray-400" data-id="element-50">{step.desc}</p>
                  </div>
                </div>)}
            </div>

            <p className="text-center text-gray-500 mt-8 italic" data-id="element-51">
              Si falta esto, todo se vuelve blando.
            </p>
          </div>
        </motion.div>

        {/* Deliverables */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-52">
          <h3 className="text-2xl md:text-3xl font-bold text-[#f0f0f0] mb-8 text-center" data-id="element-53">
            Qué incluye (entregables)
          </h3>

          <ul className="grid grid-cols-1 gap-4" data-id="element-54">
            {deliverables.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-center space-x-3 text-gray-300 border-b border-gray-800 pb-3 last:border-0" data-id="element-55">
                <CheckCircle2 className="w-5 h-5 text-[#00d4aa] flex-shrink-0" data-id="element-56" />
                <span data-id="element-57">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}